import React, { memo } from "react";
import { AntSelect } from "../../../CommonElements/AntSelect";
import { useOptions } from "./useOptions";
import { AntSekelton } from "@/Component/Skeleton";

export const SelectCountry = (props) => {
  const { options, isLoading } = useOptions();

  // ==========
  // Render
  // ==========
  return (
    <AntSelect
      loading={isLoading}
      optionFilterProp="q"
      showSearch
      options={options}
      {...props}
    />
  );
};

const Display = ({ value }) => {
  const { options, isLoading } = useOptions();
  const option = options?.find(
    (option) => String(option.value) == String(value)
  );

  return (
    <>
      {isLoading ? (
        <AntSekelton.Text active size="small" style={{ width: "100%" }} />
      ) : (
        <span className="text-muted">{option?.label || "-"}</span>
      )}
    </>
  );
};

SelectCountry.Display = memo(Display, (prevProps, nextProps) => prevProps.value === nextProps.value);
